module.exports = __webpack_public_path__ + "img/11.50c75740.jpg";